module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-11-svgrepo-com.8c610c32.svg";